import { createSlice } from '@reduxjs/toolkit';

interface AnnotationState {
  annotationData: any[];
  frameIndex: number;
  objectMapping: any[];
  workFlowConfig: any[];
  history: {
    past: any[][];
    future: any[][];
  };
}

const initialState: AnnotationState = {
  annotationData: [],
  frameIndex: 1,
  objectMapping: [],
  workFlowConfig: [],
  history: {
    past: [],
    future: []
  }
};

export const annotationSlice = createSlice({
  name: 'annotation',
  initialState,
  reducers: {
    setAnnotationData: (state, action) => {
      // Save current state to past before updating
      state.history.past.push([...state.annotationData]);
      state.annotationData = action.payload;
      // Clear future when new action is taken
      state.history.future = [];
    },
    setFrameIndex: (state, action) => {
      state.frameIndex = action.payload;
      // Clear history when changing frames
      state.history = {
        past: [],
        future: []
      };
    },
    setObjectMapping: (state, action) => {
      state.objectMapping = action.payload;
    },
    setWorkflowConfig: (state, action) => {
      state.workFlowConfig = action.payload;
    },
    undo: state => {
      if (state.history.past.length > 0) {
        // Move current state to future
        state.history.future.push([...state.annotationData]);
        // Get last state from past
        const previousState = state.history.past.pop();
        state.annotationData = previousState || [];
      }
    },
    redo: state => {
      if (state.history.future.length > 0) {
        // Move current state to past
        state.history.past.push([...state.annotationData]);
        // Get next state from future
        const nextState = state.history.future.pop();
        state.annotationData = nextState || [];
      }
    },
    clearHistory: state => {
      state.history = {
        past: [],
        future: []
      };
    }
  }
});

export const {
  setAnnotationData,
  setFrameIndex,
  setObjectMapping,
  setWorkflowConfig,
  undo,
  redo,
  clearHistory
} = annotationSlice.actions;

export default annotationSlice.reducer;
